
import { Vue, Component } from 'vue-property-decorator'
import { fetchStats, fetchStatsBreakdown } from '@/modules/biometric'

@Component
export default class Stats extends Vue {
  start_date: string = ''
  end_date: string = ''
  stats: any = {}
  items: any[] = []

  mounted(){ this.load() }

  async load(){
    const s = await fetchStats({ start_date: this.start_date || undefined, end_date: this.end_date || undefined })
    const b = await fetchStatsBreakdown({ start_date: this.start_date || undefined, end_date: this.end_date || undefined })
    this.stats = s.data || {}
    this.items = b.data.items || []
  }
}
